var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMongoDb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 28,
    viewBox: "0 0 13 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90629 28L6.16086 27.7454C6.16086 27.7454 6.25187 23.9454 4.88825 23.6727C3.97917 22.6182 5.0337 -21.0545 8.30632 23.5273C8.30632 23.5273 7.17915 24.0908 6.9791 25.0545C6.76085 26 6.90629 28 6.90629 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90629 28L6.16086 27.7454C6.16086 27.7454 6.25187 23.9454 4.88825 23.6727C3.97917 22.6182 5.0337 -21.0545 8.30632 23.5273C8.30632 23.5273 7.17915 24.0908 6.9791 25.0545C6.76085 26 6.90629 28 6.90629 28Z",
    fill: "#A6A385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30643 24.3272C7.30643 24.3272 13.8336 20.0363 12.3064 11.109C10.8337 4.61816 7.36086 2.4909 6.97913 1.67266C6.56099 1.09088 6.16089 0.0727539 6.16089 0.0727539L6.43375 18.1271C6.43375 18.1453 5.87 23.6544 7.30643 24.3272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30643 24.3272C7.30643 24.3272 13.8336 20.0363 12.3064 11.109C10.8337 4.61816 7.36086 2.4909 6.97913 1.67266C6.56099 1.09088 6.16089 0.0727539 6.16089 0.0727539L6.43375 18.1271C6.43375 18.1453 5.87 23.6544 7.30643 24.3272Z",
    fill: "#499D4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77915 24.5636C5.77915 24.5636 -0.348127 20.3817 0.0155735 13.0182C0.360902 5.65454 4.68822 2.03642 5.5245 1.38182C6.07005 0.800039 6.08825 0.581785 6.12465 0C6.50638 0.818241 6.43375 12.2364 6.48818 13.5818C6.65183 18.7636 6.19729 23.5818 5.77915 24.5636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77915 24.5636C5.77915 24.5636 -0.348127 20.3817 0.0155735 13.0182C0.360902 5.65454 4.68822 2.03642 5.5245 1.38182C6.07005 0.800039 6.08825 0.581785 6.12465 0C6.50638 0.818241 6.43375 12.2364 6.48818 13.5818C6.65183 18.7636 6.19729 23.5818 5.77915 24.5636Z",
    fill: "#58AA50"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoDb);
export default __webpack_public_path__ + "static/media/mongoDB.0cbac74ab70dec87fd92fa7265053a9d.svg";
export { ForwardRef as ReactComponent };